import { create } from 'zustand';

/** Last-crumb labels for routed entity ids. Key is the URL segment (ObjectId), value is the display name. */
export const useBreadcrumbStore = create((set) => ({
  dynamicNames: {},
  setDynamicName: (id, name) => 
    set((state) => ({
      dynamicNames: {
        ...state.dynamicNames,
        [id]: name
      }
    })),
  removeDynamicName: (id) =>
    set((state) => {
      const newDynamicNames = { ...state.dynamicNames };
      delete newDynamicNames[id];
      return { dynamicNames: newDynamicNames };
    }),
}));
